export default {
  // common.js
  baseUrl: state => state.common.baseUrl, // 网络请求地址
  logoUrl: state => state.common.logoUrl, // 银行logo地址
  webName: state => state.common.webName, // 网站平台名称
  servePhone: state => state.common.servePhone, // 服务热线
  workTime: state => state.common.workTime, // 工作时间
  serveEmail: state => state.common.serveEmail, // 服务邮箱
  copyRightCh: state => state.common.copyRightCh, // 版权中文
  copyRightEn: state => state.common.copyRightEn, // 版权英文
  // user.js
  isLogin: state => state.users.isLogin, // 获取登录状态
  userId: state => state.users.userId, // 获取用户userId
  userName: state => state.users.userName, // 获取用户名
  chksts: state => state.users.chksts,
  isEmail: state => state.users.isEmail,//邮箱状态
  email: state => state.users.email,//邮箱
  newEmail: state => state.users.newEmail,//用户更换邮箱
  schedule: state => state.users.schedule,//用户注册流程
  goPage: state => state.users.goPage,//授权认证和完善企业信息页面刷新时的页面地址
  updcardsch: state => state.users.updcardsch,
  updcussch: state => state.users.updcussch,
}



// WEBPACK FOOTER //
// ./src/store/getters.js